import {
	Button,
	Center,
	Input,
	Radio,
	RadioGroup,
	Stack,
} from '@chakra-ui/react';

const FiltrosEstadisticas = ({
	filters,
	handleFilterChange,
	handleTipoChange,
	handleAplicarFiltro,
}) => (
	<Center>
		<Stack direction='column' spacing={0} align='center'>
			<RadioGroup
				value={filters.tipo}
				onChange={handleTipoChange}
				w='100%'
				rounded='none'
				p={2}
			>
				<Stack direction='row' spacing={4} mt={4}>
					<Radio value='general'>General</Radio>
					<Radio value='agencias'>Agencias</Radio>
					<Radio value='trabajadores'>Trabajadores</Radio>
				</Stack>
			</RadioGroup>
			<Stack direction='row' spacing={2} align='center'>
				<Input
					name='ultimosDias'
					type='number'
					placeholder='Últimos N días'
					value={filters.ultimosDias}
					onChange={handleFilterChange}
				/>
				<Button
					onClick={handleAplicarFiltro}
					m={2}
					colorScheme='blue'
					size='sm'
					w='100%'
				>
					Aplicar filtros
				</Button>
			</Stack>
		</Stack>
	</Center>
);

export default FiltrosEstadisticas;
